import { useEffect, useState } from 'react';

import {
  widgetDemoUrl,
  type WebLinkConfig,
} from '../WebLinkGeneratorTab/utils/const';

export type HookWebLinkGeneratorProps = {
  agentId: string;
};

export const defaultForm: WebLinkConfig = {
  baseUrl: widgetDemoUrl,
  typeLink: 'widget',
  variantLink: 'default',
  authUrl: process.env.REACT_APP_LEVKIT_BASE_URL,
  authToken: process.env.REACT_APP_AUTHORIZATION_TOKEN,
};

export type WebLinkGeneratorFormProps = {
  web_link_generator: WebLinkConfig;
};

export const useWebLinkGenerator = ({ agentId }: HookWebLinkGeneratorProps) => {
  const [formId, setFormId] = useState(1);
  const [form, setForm] = useState<WebLinkGeneratorFormProps>({
    web_link_generator: defaultForm,
  });

  useEffect(() => {
    if (!agentId) return;

    setForm(prev => {
      if (prev.web_link_generator?.agentId === agentId) return prev;

      return {
        ...prev,
        web_link_generator: {
          ...prev.web_link_generator,
          agentId,
        },
      };
    });
    setFormId(f => f + 1);
  }, [agentId]);

  return {
    form,
    formId: String(formId),
    onChange: setForm,
    setFormId,
    setForm,
  };
};
